import React, { Component } from 'react';
import FadeIn from 'react-fade-in';

class RestartButton extends Component {
  restart = (e) => {
    e.preventDefault();
    this.props.restart();
  };

  render() {
    if (!this.props.timerPassed) {
      return null;
    } else {
      return (
        <FadeIn className='pos-right'>
          <button
            type='button'
            className='button btn-underline btn-center hide-on-print'
            onClick={this.restart}
          >
            Restart
          </button>
        </FadeIn>
      );
    }
  }
}

export default RestartButton;
